export default __webpack_public_path__ + "static/media/presentation.cfe1efd3.svg";